module.exports = __webpack_public_path__ + "img/1(14).42c925c0.png";